module.exports = __webpack_public_path__ + "static/media/footsteps-small.96544fea.svg";